import assign from 'lodash/assign';
import debug from 'lib/common/debug';
import features from 'lib/common/features';

function event(options) {
    var metricData = assign({
        'hitType': 'event',
        'eventCategory': 'SYOS'
    }, options);

    if (features.isEnabled('metrics')) {
        /* global ga */
        if (window.ga) {
            var gaId;
            try {
                gaId = ga.getAll()[0].get('name')
            } catch (e) {} // eslint-disable-line no-empty
            if (gaId) {
                ga(`${gaId}.send`, metricData);
            }
        }

        debug.info('[Metrics event]', metricData);
    }
}

function action(actionValue, labelValue) {
    event({
        eventAction: actionValue,
        eventLabel: labelValue
    });
}

export default {
    event,
    action
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/metrics.js